<div style="display: flex; flex-direction: column">
  <div class="add-colonne">
    @if (data.tipo === 'COLONNA') {
      <div appFormContainer [larghezza]="4">
        <fieldset appFormElement [larghezza]="4" [riempi]="true" class="bordo">
          <legend>{{ data.elemento ? 'Modifica' : 'Aggiungi' }} colonna</legend>

          <div class="cnt-colonne">
            <mat-form-field
              #tipologia
              (mousedown)="$event.stopPropagation()"
              appFormElement
              [larghezza]="1"
              [riempi]="true"
            >
              <mat-label>Tipologia Colonna</mat-label>
              <mat-select
                [(ngModel)]="colonna.tipoColonna"
                name="tipologiaSelezionata"
                [required]="true"
              >
                <mat-option *ngFor="let tpRisp of arrayTipologiaColonna" [value]="tpRisp.chiave">
                  {{ tpRisp.valore }}
                </mat-option>
              </mat-select>
              <mat-error appFormError></mat-error>
            </mat-form-field>

            @if (colonna.tipoColonna === 'UM') {
              <app-autocomplete
                appFormElement
                [larghezza]="2"
                [riempi]="true"
                [(ngModel)]="categoriaUnitaSelezionata"
                name="categoriaUnitaSelezionata"
                [label]="'Categorie'"
                [loadDataFn]="loadDataFnGetCategorie"
                [displayFn]="displayFn"
                [required]="true"
                [chiaveId]="'id'"
                [numeroRecOptions]="infiniteRecords"
              >
              </app-autocomplete>

              <mat-form-field class="input-form" appFormElement [larghezza]="2" [riempi]="true">
                <mat-label>Unità di Misura di Riferimento</mat-label>
                <mat-select
                  [(ngModel)]="colonna.unitaDiMisura"
                  name="selectedUnitaDiMisura"
                  required
                  [compareWith]="compareById"
                  [disabled]="categoriaUnitaSelezionata === undefined"
                  placeholder="Unità di Misura di Riferimento"
                >
                  <mat-option
                    *ngFor="let um of categoriaUnitaSelezionata?.unitaDiMisura"
                    [value]="um"
                  >
                    {{ um.descrizione }}
                  </mat-option>
                </mat-select>
                <mat-error appFormError></mat-error>
              </mat-form-field>
            }
          </div>
          <div appFormContainer [larghezza]="4">
            <mat-form-field appFormElement [larghezza]="4" [riempi]="true">
              <mat-label>Colonna</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                [disabled]="
                  !colonna.tipoColonna || (colonna.tipoColonna === 'UM' && !colonna.unitaDiMisura)
                "
                placeholder="Colonna"
                [(ngModel)]="colonna.label"
                rows="3"
              ></textarea>

              @if (colonna.unitaDiMisura) {
                <span
                  matTextSuffix
                  style="font-size: 12px"
                  [matTooltip]="colonna.unitaDiMisura.descrizione"
                  >{{ colonna.unitaDiMisura.nomeBreve }}&nbsp;</span
                >
              }
            </mat-form-field>
          </div>
        </fieldset>
      </div>
    } @else if (data.tipo === 'RIGA') {
      <div appFormContainer [larghezza]="3">
        <fieldset appFormElement [larghezza]="3" [riempi]="true" class="bordo">
          <legend>{{ data.elemento ? 'Modifica' : 'Aggiungi' }} riga</legend>

          <div appFormContainer [larghezza]="3">
            <mat-form-field appFormElement [larghezza]="3">
              <mat-label>Riga</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                placeholder="Riga"
                [(ngModel)]="riga.label"
                rows="3"
              ></textarea>
            </mat-form-field>
          </div>
        </fieldset>
      </div>
    }
  </div>
  <div class="cnt-btn">
    <button mat-raised-button color="accent" class="accent-button" (click)="chiudi()">
      Chiudi
    </button>
    @if (this.data.elemento) {
      <button mat-raised-button color="warn" class="accent-button" (click)="elimina()">
        Elimina {{ data.tipo === 'COLONNA' ? 'colonna' : 'riga' }}
      </button>
    }
  </div>
</div>
